module.exports = __webpack_public_path__ + "img/fi.e465dfd6.svg";